import { entries } from "@/mocks/entries";
import { categories } from "@/mocks/categories";

export function getEntryById(id: string) {
  return entries.find((item) => item.id === id) ?? null;
}

export function getCategoryBySlug(slug: string) {
  return categories.find((item) => item.slug === slug) ?? null;
}

export function getCategoryName(slug: string) {
  return getCategoryBySlug(slug)?.name ?? slug;
}

export function getEntriesByCategory(slug: string) {
  return entries
    .filter((item) => item.category === slug)
    .sort((a, b) => b.heat - a.heat);
}

export function getRelatedEntries(ids: string[]) {
  return ids
    .map((id) => getEntryById(id))
    .filter((item): item is NonNullable<typeof item> => Boolean(item));
}

export function formatHeat(value: number) {
  return value.toLocaleString("zh-CN");
}

export function formatDate(value: string) {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
}